import Loading from "shared/components/Spin";
import { useWindowSize } from "shared/hooks/resize";

const Loader = () => {
  const [, height] = useWindowSize();
  return <Loading />;
};

Loader.propTypes = {};

Loader.defaultProps = {};

export default Loader;
